import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const SID_KEY = "eplay_sid";

function getOrCreateSid() {
  if (typeof window === "undefined") return null;
  try {
    let sid = window.localStorage.getItem(SID_KEY);
    if (!sid) {
      // Prefer the standards-compliant UUID; fall back to a hand-rolled id.
      sid = (window.crypto && typeof window.crypto.randomUUID === "function")
        ? window.crypto.randomUUID()
        : `anon-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

function normalizeRoute(pathname) {
  if (!pathname) return "/";
  // Strip trailing slash except for root
  if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname;
}

/**
 * Page-view tracker. Fires a debounced `POST /api/track/impression` every
 * time the React Router pathname changes. The backend dedupes by
 * (actor, route, 5-minute bucket), so rapid reloads cost nothing.
 */
export default function usePageView() {
  const loc = useLocation();

  useEffect(() => {
    const sid = getOrCreateSid();
    const route = normalizeRoute(loc.pathname);
    // Fire and forget — tracking must never block render or show toasts.
    api.post("/track/impression", { route, session_id: sid }).catch(() => { /* noop */ });
  }, [loc.pathname]);
}
